import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismTable,
  PrismTableHeadersThSublabel,
} from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdNonComputable from 'lumen/components/hotel/strategy/tables/cells/td-non-computable';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import HotelStrategyTablesCellsThStrategyDetail from 'lumen/components/hotel/strategy/tables/cells/th-strategy-detail';
import { MEALTYPES } from 'lumen/utils/constants/general-constants';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
  SUBTYPE_VALUES_KEY_STRATEGY,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailMealtypeSignature {
  Args: {
    initialSorts: unknown;
    onTableSort: unknown;
    sortFunction: unknown;
    subtypes: unknown;
  };
}

export default class HotelStrategyTablesTableDetailMealtype extends Component<HotelStrategyTablesTableDetailMealtypeSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const valuePathRoomOnly = `${COLUMN_PROPERTIES.ROOM_ONLY}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO_HEADER,
        subcolumns: [
          {
            ...COLUMN_CONFIG.HOTELINFO,
            name: this.intl.t('general.hotels'),
            tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
            valuePath: valuePathHotel,
          },
        ],
      },
      {
        width: COLUMN_WIDTH.DEFAULT,
        columnKey: MEALTYPES.ROOM_ONLY,
        hasRightBorder: true,
        hasCompareButton: true,
        thComponent: HotelStrategyTablesCellsThStrategyDetail,
        subcolumns: [
          {
            name: this.intl.t('rates.meal.room_only'),
            valuePath: valuePathRoomOnly,
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            columnKey: MEALTYPES.ROOM_ONLY,
            hasCompareButton: true,
            textAlign: 'center',
            hasRightBorder: true,
          },
        ],
      },
    ];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.subtypes.forEach((subtype) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRate = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathSupplement = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.SUPPLEMENT}`;

      columns.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        name: subtype.label,
        thComponent: HotelStrategyTablesCellsThStrategyDetail,
        width: 2 * COLUMN_WIDTH.DEFAULT,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: subtype.label,
        textAlign: 'center',
        hasRightBorder: true,
        hasCompareButton: true,
        subtypeHeaderAttributes: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileBookingSubtype: subtype.isMobileBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileExpediaSubtype: subtype.isMobileExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMealtypeType: subtype.isMealtypeType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosBookingSubtype: subtype.isPosBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosExpediaSubtype: subtype.isPosExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          isBranddotcomMemberRatesSubType:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            subtype.isBranddotcomMemberRatesSubType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMemberRatesType: subtype.isMemberRatesType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          label: subtype.label,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          formattedLabel: subtype.formattedLabel[SUBTYPE_VALUES_KEY_STRATEGY],
        },
        subcolumns: [
          {
            name: this.intl.t('strategy.mealtype.supplement'),
            subLabel: this.intl.t('strategy.per_person'),
            valuePath: valuePathSupplement,
            thComponent: PrismTableHeadersThSublabel,
            thClassNames: 'truncate text-200--bold',
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdNonComputable,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
          },
          // @ts-expect-error: Incorrect type
          {
            name: this.intl.t('rates.rate'),
            valuePath: valuePathRate,
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            hasRightBorder: true,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: subtype.label,
          },
        ],
      });
    });

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const mealtypeData = [...this.args.mealtypeDataPerHotelInfo.values()];

    mealtypeData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        [`${COLUMN_PROPERTIES.ROOM_ONLY}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`]:
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[COLUMN_PROPERTIES.ROOM_ONLY][COLUMN_PROPERTIES.RATE],
      };

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.subtypes.forEach((subtype) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.RATE];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        row[
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.SUPPLEMENT}`
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ] = rowData[subtype.id][COLUMN_PROPERTIES.SUPPLEMENT];
      });

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@initialSorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container"
    />
  </template>
}
